import { Ufc } from '@/utils/program/idl/type';
import { Program } from '@coral-xyz/anchor';
import { PublicKey } from '@solana/web3.js';
import { BN } from 'bn.js';

export const getVaultAddr = (program: Program<Ufc>) => {
  const [address] = PublicKey.findProgramAddressSync(
    [Buffer.from('vault')],
    program.programId
  );

  return address;
};

export const getGameAddr = (data: {
  gameId: InstanceType<typeof BN> | number;
  program: Program<Ufc>;
}) => {
  const [address] = PublicKey.findProgramAddressSync(
    [Buffer.from('game'), new BN(data.gameId).toArrayLike(Buffer, 'le', 8)],
    data.program.programId
  );

  return address;
};

export const getInstantGameAddr = (data: {
  program: Program<Ufc>;
  gameId: InstanceType<typeof BN> | number;
}) => {
  const [address] = PublicKey.findProgramAddressSync(
    [
      Buffer.from('instant_game'),
      new BN(data.gameId).toArrayLike(Buffer, 'le', 8),
    ],
    data.program.programId
  );
  return address;
};
